import { render, staticRenderFns } from "./NsRadioGroup.vue?vue&type=template&id=c6d2172a&scoped=true&"
import script from "./NsRadioGroup.vue?vue&type=script&lang=js&"
export * from "./NsRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./NsRadioGroup.vue?vue&type=style&index=0&id=c6d2172a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2172a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d2172a')) {
      api.createRecord('c6d2172a', component.options)
    } else {
      api.reload('c6d2172a', component.options)
    }
    module.hot.accept("./NsRadioGroup.vue?vue&type=template&id=c6d2172a&scoped=true&", function () {
      api.rerender('c6d2172a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsRadioGroup.vue"
export default component.exports